module.exports = __webpack_public_path__ + "static/media/eyar.5f342042.jpg";